import { render, staticRenderFns } from "./Termo.vue?vue&type=template&id=6230b5f4&"
import script from "./Termo.vue?vue&type=script&lang=js&"
export * from "./Termo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports